import { render, staticRenderFns } from "./standardSetting.vue?vue&type=template&id=dafcc48a&scoped=true"
import script from "./standardSetting.vue?vue&type=script&lang=js"
export * from "./standardSetting.vue?vue&type=script&lang=js"
import style0 from "./standardSetting.vue?vue&type=style&index=0&id=dafcc48a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafcc48a",
  null
  
)

export default component.exports